import { AgentRole, SpaceModel } from "../../interfaces/Space"
import '../../styles/layouts/infotech.scss'

type Props = {
    space: SpaceModel
}

const hasPastAgents = (space: SpaceModel) => {
    const arr = space.pastAgents;
    const content = arr?.reduce((acc: string, ag: string) => {
        return `${acc}${ag}`
    }, '')

    return arr && content;
}


const getTechArray = (arr: string[]) => {
    return <div className="infotech-agentroles-container">
        {arr.map((agent: string, idx) => {
            return `${agent}${idx === arr!.length - 1 ? '' : ', '}`;
        })}
    </div>
}

const getTech = (space: SpaceModel) => {
    if (space.agentRoles && space.agentRoles.length > 0) {
        return <div className="infotech-agentroles-container-wrapper">
            {space.agentRoles.map((ar: AgentRole, idx: number) => {
                return <div key={`${ar.role}${idx}`} className="infotech-agentroles-container">
                    {`${ar.role}: `}
                    {ar.agents.map((agent: string, idx) => {
                        return `${agent}${idx === ar.agents.length - 1 ? '' : ', '}`;
                    })}
                </div>
            })
            }
        </div >
    } else if (space?.properties?.agents && space.properties.agents.length > 0) {
        return <div className="infotech-agents-container">
            <div>Agentes:</div>
            {getTechArray(space.properties.agents)}
        </div>
    }
}

export default function InfoTech({ space }: Props) {
    return <div>
        {getTech(space)}
        {hasPastAgents(space) &&
            <div>
                <div className="infotech-subtitle">Agentes Passados:</div>
                <div>
                    {getTechArray(space.pastAgents!)}
                </div>
            </div>}

    </div>
}